module.exports = __webpack_public_path__ + "img/PL08494.9b066604.png";